import { useEffect, useState } from "react";

const useMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    checkingScreenSize();
    window.addEventListener("resize", () => checkingScreenSize());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkingScreenSize = () => {
    if (window.innerWidth <= 768) {
      setIsMobile(true);
    } else {
        setIsMobile(false);
    }
  }
  
  return isMobile;
}

export default useMobile;
